/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import Alert from "../Alert";
import BaseCom from "../BaseCom";
import LoadingAlert from "../LoadingAlert";
import { SidebarGlobal } from "../_Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import { Pop } from "../PopModal";
import "./Billing.css";
import Auth from '../../shared/Auth';
import { Modal } from "react-bootstrap";
import L from "../Lang";

class ClaimList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: null
        };
    }

    async componentDidMount() {
        this.applyThemeColors();

        await this.load();
        this.applyThemeColors();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {

        this.setState({ loading: true });
        try {
            var j = await qreq.getAsync('/api/claim/list');
            if (j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.alert(e);
        }

    }

    deleteSelected = async () => {
        let ids = this.state.list.filter(i => i.selected).map(i => i.id);
        if (ids.length === 0) {
            this.warning('No claims selected.');
            return
        }
        Pop.showConfirm(`Delete ${ids.length} claims?`, 'Delete Claims', async () => {
            this.setState({ submitting: true });
            try {
                let j = await qreq.postAsync('/api/claim/delete', { ids: ids });
                if (j.errorCode === 0) {
                    this.success('Deleted claims successfully.');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                console.error(e);
                this.unkownErrorCallback();
            }
            this.setState({ submitting: false });
        });
    }

    toggleItem = (e, row) => {
        row.selected = e.target.checked;
        this.setState({ list: this.state.list });
    }

    toggleAll = (e) => {
        this.state.list.forEach(i => {
            if (!i.isReadyToSend || !i.isSent)
                i.selected = e.target.checked;
        });
        this.setState({ list: this.state.list });
    }

    isAllSelected = () => {
        return this.state.list.filter(i => i.selected).length === this.state.list.length;
    }

    send = async (reportOnly) => {
        let ids = this.state.list.filter(i => i.selected).map(i => i.id);
        if (ids.length === 0) {
            this.warning('No claims selected.');
            return
        }
        Pop.showConfirm(reportOnly ? `Create report for ${ids.length} claims?` : `Send ${ids.length} claims?`, reportOnly ? 'Report Claims' : 'Send Claims', async () => {
            this.setState({ submitting: true });
            try {
                let j = await qreq.postAsync('/api/claim/send?reportOnly=' + (reportOnly ? 'true' : 'false'), { ids: ids });
                if (j.errorCode === 0) {
                    this.success(reportOnly ? 'Reported claims successfully.' : 'Sent claims successfully.');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                console.error(e);
                this.unkownErrorCallback();
            }
            this.setState({ submitting: false });
        });
    }

    showClaimError = (row) => {
        Pop.show(<p>{row.statusMessage}</p>, 'Claim Error');
    }

    showDetail = async (row) => {
        this.setState({ showDetailModal: true });
        let j = await this.getAsync('/api/claim/' + row.id);
        if (j.item)
            this.setState({ currentItem: j.item });
    }

    render() {
        if (!this.state.list) return <LoadingAlert />;

        SidebarGlobal.setSubNav(<>
            <Link to="/claim/new" role="button" className="btn btn-primary"><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>Generate Claims</L></span></Link>
            <button className="btn btn-success" onClick={() => this.send(false)} disabled={this.state.submitting}><Icon icon="faMoneyBillTransfer" /> <span className="d-none d-md-inline"><L>Send Claims</L></span></button>
            {Auth.hasRole('!') && <button className="btn btn-warning" onClick={() => this.send(true)} disabled={this.state.submitting}><Icon icon="faMoneyBillTransfer" /> <span className="d-none d-md-inline"><L>Test Claims</L></span></button>}
            <button className="btn btn-danger" onClick={this.deleteSelected} disabled={this.state.submitting}><Icon icon="faTrash" /> <span className="d-none d-md-inline"><L>Trash</L></span></button>
        </>);

        return <div className="container-fluid">


            <Modal show={this.state.showDetailModal} onHide={() => this.setState({ showDetailModal: false, currentItem: null })}>
                <Modal.Header>
                    <Modal.Title><L>Claim #</L> {this.state.currentItem?.id}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.currentItem ? <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between">
                            <div><L>Claim</L> 1 of {this.state.currentItem?.totalClaims} <span className="text-primary">{this.state.currentItem?.id}</span>
                                {this.state.currentItem?.checkNumber && <div><small>CHK #{this.state.currentItem?.checkNumber}</small></div>}
                            </div>
                            <div className="text-muted">{this.state.currentItem?.status}</div>
                        </li>
                        {this.state.currentItem?.claims?.map((i, idx) => <li key={idx} className="list-group-item d-flex justify-content-between">
                            <div>
                                <L>Claim</L> {(idx + 2)} of {this.state.currentItem?.totalClaims} <span className="text-primary">{i.id}</span>
                                {i.checkNumber && <div className="text-muted"><small>CHK #{i.checkNumber}</small></div>}
                            </div>
                            <div>{i.status}</div>
                        </li>)}
                    </ul> : <LoadingAlert />}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showDetailModal: false, currentItem: null })}>
                        <L>Close</L>
                    </button>
                </Modal.Footer>
            </Modal>





            <h1><L>Claims</L></h1>
            <table className="table table-striped c-datatable">
                <thead>
                    <tr>
                        <th style={{ width: '25px' }}>
                            {this.state.list.filter(a => !a.isReadyToSend).length > 0 && <input type="checkbox" onChange={this.toggleAll} checked={this.isAllSelected()} />}
                        </th>
                        <th><L>ID</L></th>
                        <th><L>Patient Name</L></th>
                        <th><L>Service Date</L></th>
                        <th><L>Claim Count</L></th>
                        <th><L>Total Amount</L></th>
                        <th><L>Status</L></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.list.map((row, idx) => <tr key={idx}>
                        <td>
                            {row.isReadyToSend ? <Icon icon="faCheck" className="text-primary" />
                                : <input type="checkbox" onChange={e => this.toggleItem(e, row)} checked={row.selected} />}
                        </td>
                        <td><Link to={`/claim/${row.id}`}>{row.id}</Link></td>
                        <td><Link to={`/claim/${row.id}`}>{`${row.patient.firstName} ${row.patient.lastName} (${row.patient.birthDate})`}</Link></td>
                        <td>{Globals.toMDYLocalDateString(row.serviceDate)}</td>
                        <td>{row.totalClaims}</td>
                        <td>{row.totalAmount ? Globals.getCurrencyFormatter().format(row.totalAmount) : 'N/A'}</td>
                        <td>
                            <span role="button" onClick={() => this.showDetail(row)}>
                                {row.collectiveStatus === 'Error' ? <span className="text-danger" role="button" onClick={() => this.showClaimError(row)}>{row.collectiveStatus}</span>
                                    : row.collectiveStatus?.indexOf('Paid') >= 0 ? <span className="text-success">{row.collectiveStatus}</span>
                                        : row.collectiveStatus === 'ReadyToSend' ? <span className="text-primary">{row.collectiveStatus}</span>
                                            : row.collectiveStatus}
                            </span>
                        </td>
                    </tr>)}
                </tbody>
            </table>
            {this.state.list.length === 0 && <Alert type="info"><L>No claims found.</L></Alert>}
        </div>;
    }
}

export default withParamsAndNavigate(ClaimList);